import { css } from 'styled-components'

export default css`
  &.LowBalanceAlertField {
    display: flex;
    flex-direction: column;

    .header-row {
      display: flex;
      align-items: center;
      gap: 8px;

      /* FieldLabel ships with margin-bottom: 8px for stacked input layouts;
         strip it here so the tooltip icon visually aligns with the title. */
      label {
        margin-bottom: 0;
      }
    }

    .checkbox-row {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 16px;
    }

    &.is-disabled .checkbox-label {
      opacity: 0.5;
    }

    .threshold-row {
      margin-top: 16px;
      width: 100%;
    }
  }
`
